// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mew-progress-bar[data-v-0e9a9729] {\n  background-color: var(--v-primaryOutlineActive-base);\n  border-radius: 8.5px;\n}\n.mew-progress-bar .left-border-radius[data-v-0e9a9729] {\n  border-top-left-radius: 8.5px;\n  border-bottom-left-radius: 8.5px;\n}\n.mew-progress-bar .right-border-radius[data-v-0e9a9729] {\n  border-top-right-radius: 8.5px;\n  border-bottom-right-radius: 8.5px;\n}", ""]);
// Exports
module.exports = exports;
